import { observer } from 'mobx-react';
import ImportParticipantsStore from '../Store';
import { SubmitSucceeded } from '../Store/Types';
import Footer from './Footer';
import ImportStatus from './ImportStatus';

interface Props {
  store: ImportParticipantsStore;
  state: SubmitSucceeded;
}

function ImportParticipantsStatus({ store, state }: Props) {
  const { importedParticipantsResource, initialCount } = state;
  return (
    <div className="flex flex-col items-center px-2.5 py-12 lg:px-10">
      <div className="lg:w-[55%]">
        <ImportStatus
          importedParticipants={importedParticipantsResource.payload}
          totalCount={initialCount}
          store={store}
        />
        <Footer successfulParticipantsResource={importedParticipantsResource} />
      </div>
    </div>
  );
}

export default observer(ImportParticipantsStatus);
